module.exports = __webpack_public_path__ + "img/img24.8f7e86fe.svg";